// Početna stranica dobija iz API-ja ~285 KB JSON-a, a deo polja (opisi, sadržaj vesti...)
// nijedan widget na njoj ne prikazuje. Sve što useAsyncData vrati ide u __NUXT_DATA__
// (payload), pa se ovde uklanja samo ono što se ne koristi.
//
// Polja koja se ne koriste proverena su po widgetima sa početne (Event/*, Newspaper/*,
// Recipe/*, Follow/*, Advertisement/TopAds*, Price/TopPriceBase, Market/*).
// Ako neki widget počne da prikazuje npr. event.description, izbaci ga iz DROP liste.

const DROP = {
  events: ['description', 'description_meta'],
  ads: ['description'],
  newspapers: ['content', 'description_meta'],
  recipes: ['description', 'description_meta'],
  medicines: ['description', 'description_meta'],
  suggestions: ['lawyers'],
}

// TopPriceBase koristi samo category.description + subcategory.description/svg/color (+ id, name)
const CATEGORY_DROP = ['text', 'description_meta']
const SUBCATEGORY_KEEP = ['id', 'name', 'description', 'svg', 'color']

const omit = (obj, fields) => {
  const copy = { ...obj }
  for (const f of fields) delete copy[f]
  return copy
}

const pick = (obj, fields) =>
  Object.fromEntries(fields.filter(f => f in obj).map(f => [f, obj[f]]))

export function slimIndexPage(res) {
  const data = res?.data
  if (!data) return res

  const slim = { ...data }

  for (const [key, fields] of Object.entries(DROP)) {
    if (Array.isArray(data[key])) {
      slim[key] = data[key].map(item => omit(item, fields))
    }
  }

  if (Array.isArray(data.categories)) {
    slim.categories = data.categories.map(cat => ({
      ...omit(cat, CATEGORY_DROP),
      subcategories: Array.isArray(cat.subcategories)
        ? cat.subcategories.map(sub => pick(sub, SUBCATEGORY_KEEP))
        : cat.subcategories,
    }))
  }

  return { ...res, data: slim }
}
